import { useEffect, useState } from 'react';

import { api } from './api';
import { CloseIcon, TrashIcon } from './icons';

export interface DeletableInboundInvoice {
  id: string;
  sku: string;
  partnerName: string;
  updatedAt: string;
}

export function InboundDeleteModal({
  invoice,
  onClose,
  onDeleted
}: {
  invoice: DeletableInboundInvoice;
  onClose: () => void;
  onDeleted: (message: string) => void;
}) {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !deleting) onClose();
    };
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, [deleting, onClose]);

  async function remove() {
    setDeleting(true);
    setError('');
    try {
      const result = await api<{ invoice: { message?: string } }>(`/api/invoices/inbound/${invoice.id}`, {
        method: 'DELETE',
        body: JSON.stringify({ updatedAt: invoice.updatedAt })
      });
      onDeleted(result.invoice.message || `Đã xóa hóa đơn ${invoice.sku}.`);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Không thể xóa hóa đơn.');
    } finally {
      setDeleting(false);
    }
  }

  return (
    <div className="drawer-backdrop" role="presentation">
      <section className="confirm-modal" role="dialog" aria-modal="true" aria-labelledby="delete-invoice-title">
        <header className="drawer-header">
          <h2 id="delete-invoice-title">Xóa hóa đơn nhập</h2>
          <button type="button" className="icon-button" onClick={onClose} disabled={deleting} aria-label="Đóng"><CloseIcon /></button>
        </header>
        <div className="confirm-content">
          <p>Bạn có chắc muốn xóa <strong>{invoice.sku}</strong> của <strong>{invoice.partnerName}</strong>?</p>
          <p>Hệ thống chỉ cho xóa khi hóa đơn chưa thanh toán, chưa trả hàng và toàn bộ lô vẫn còn nguyên. Tồn kho liên quan sẽ được hoàn tác trong cùng giao dịch.</p>
          {error ? <div className="detail-error" role="alert">{error}</div> : null}
        </div>
        <footer className="drawer-footer">
          <button type="button" className="secondary-action" onClick={onClose} disabled={deleting}>Hủy</button>
          <button type="button" className="danger-action" onClick={() => void remove()} disabled={deleting}>{deleting ? <span className="button-spinner" /> : <TrashIcon />} {deleting ? 'Đang xóa…' : 'Xóa hóa đơn'}</button>
        </footer>
      </section>
    </div>
  );
}
